import React from "react";
import { Typography, Popover, Tag } from "antd";
import { ExportOutlined } from "@ant-design/icons";
const { Text } = Typography;

const ContentLinkExternalFNT = ({ title, url }) => {
  return (
    <>
      <Popover
        color="#fff"
        placement="topRight"
        content={
          <div>
            <a
              href={url}
              target="_blank"
              rel="noreferrer noopener"
              style={{
                color: "#e00916",
                marginBottom: "24px",
                textDecoration: "underline",
                textTransform: "capitalize",
              }}
            >
              <img
                src="/img/logo-fnt.png"
                alt="Logo Federatie Nationale Trombosediensten"
                width={48}
                style={{ marginRight: "8px", top: "-2px" }}
              />
              <span style={{ fontSize: "14px" }}>FNT {"> "}</span>
              {title}
            </a>
            <br />
            <Text style={{ fontSize: "11px", color: "#704f4f" }}>
              <ExportOutlined style={{ transform: "rotate(-90deg)" }} /> opent
              in een nieuw venster
            </Text>
          </div>
        }
        trigger="hover"
      >
        <Tag style={{ margin: "0" }}>
          <Text
            style={{
              textDecoration: "underline",
              textDecorationColor: "#e00916",
              textTransform: "capitalize",
            }}
          >
            <img
              src="/img/favicon-fnt.ico"
              alt="Favicon FNT"
              width={16}
              style={{ marginRight: "8px", top: "-2px", position: "relative" }}
            />
            {"> "}
            {title}
            <ExportOutlined
              style={{
                transform: "rotate(-90deg)",
                color: "#e00916",
                marginLeft: "2px",
              }}
            />
          </Text>
        </Tag>
      </Popover>
    </>
  );
};

export default ContentLinkExternalFNT;
